import React from "react";
import { Shield } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function KampenForDeUfodte() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section id="kampen-for-de-ufødte" className="dark bg-background text-foreground relative overflow-hidden py-24 md:py-32">
      {}
      <div className="absolute inset-0 flex items-center justify-center select-none pointer-events-none overflow-hidden z-0">
        <span className="text-[18vw] md:text-[15vw] font-black text-destructive/10 whitespace-nowrap leading-none tracking-tighter opacity-20 mix-blend-overlay">
          1.000.000
        </span>
      </div>
      
      {}
      <div className="absolute inset-0 bg-background/50 z-0 pointer-events-none" />

      <div className="container relative z-10 mx-auto px-4 flex justify-center">
        <div ref={ref} className={`transition-all duration-1000 ease-out transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"} w-full max-w-3xl`}>
          <Card className="w-full border-2 border-destructive/30 bg-card/95 backdrop-blur-md shadow-2xl shadow-black/80 rounded-none">
            <CardHeader className="text-center space-y-6 pt-12 pb-2">
              <div className="mx-auto bg-destructive/10 p-5 rounded-none border border-destructive/20 w-fit mb-2">
                <Shield className="w-10 h-10 text-destructive" />
              </div>
              <CardTitle className="text-4xl md:text-5xl font-serif font-bold tracking-tight text-foreground uppercase drop-shadow-md">
                Christian Bak: Samfund, Disciplin & Tro
              </CardTitle>
            </CardHeader>
            
            <CardContent className="text-center space-y-8 px-6 md:px-16 py-8">
              <p className="text-xl md:text-2xl text-muted-foreground font-serif leading-relaxed border-b border-border/50 pb-8">
                Dette er Christian Baks <span className="text-foreground font-bold">digitale fort</span> – en bastion for samfund & moral, disciplin & karakterstyrke samt tro & eksistens, der kompromisløst forsvarer sandheden mod politisk korrekthed.
              </p>
              <p className="text-base md:text-lg text-muted-foreground leading-relaxed max-w-2xl mx-auto">
                Som tidligere garder forener Christian Bak militær disciplin med kristen etik for at genrejse nationens karakterstyrke. I kampen mod de 1.000.000 aborter står han som en disciplineret kriger for de ufødte, rede til at knuse tidsåndens hykleri gennem bøn og ubøjelig moralsk genopbygning.
              </p>
            </CardContent>
            
            <CardFooter className="justify-center pb-14 pt-4">
              <Button asChild size="lg" className="bg-destructive text-destructive-foreground hover:bg-destructive/80 text-lg px-10 py-7 rounded-none uppercase tracking-widest font-bold border-2 border-transparent hover:border-destructive-foreground/20 transition-all shadow-lg">
                <Link to="/FrontlinePage">
                  Kampen for Livet
                </Link>
              </Button>
            </CardFooter>
          </Card>
        </div>
      </div>
    </section>;
}